@if(isChart()){
<div class="w-full flex flex-col items-center justify-center gap-4 
                                 px-8 py-14 border border-zen-neutralp90 bg-zen bg-opacity-10 rounded-lg">
    <i class="fa-light fa-chart-column text-5xl text-zen-neutralp70"></i>

    <h2 class="text-lg font-medium text-center text-zen-dark">
        {{ "txt_Insuffici_103" | translate:langauge:moduleName.Engagement }}
    </h2>
    <!-- 
    <p class="text-sm text-center text-primary-light">
        {{ "txt_Theselect_919" | translate:langauge:moduleName.Engagement }}
    </p> -->
</div>
}
@else{
<div class="w-full min-h-screen-40 flex flex-col justify-center items-center gap-6 text-zen">
    <div class="flex flex-row justify-center items-center w-full">
        <lottie-player [src]="empty" background="transparent" background="transparent" speed="1"
            style="width: 25rem"></lottie-player>
    </div>
    <ng-content></ng-content>
</div>
}